(() => {
  async function refreshDrawerAndNotify() {
    const cd = document.querySelector('cart-drawer');
    if (!cd) return;

    // 1) ia starea reală a coșului
    const cartRes = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    if (!cartRes.ok) throw new Error('Cart state fetch failed');
    const cartState = await cartRes.json();

    // 2) cere secțiuni pentru rerender (Dawn-style)
    // Dacă tema ta are getSectionsToRender, folosește-o (cel mai corect)
    let sectionIds = [];
    if (typeof cd.getSectionsToRender === 'function') {
      sectionIds = cd.getSectionsToRender().map((s) => s.id).filter(Boolean);
    }

    // fallback minimal dacă metoda nu există
    if (!sectionIds.length) sectionIds = ['cart-drawer', 'cart-icon-bubble'];

    const sectionsRes = await fetch(`/?sections=${encodeURIComponent(sectionIds.join(','))}`);
    if (!sectionsRes.ok) throw new Error('Sections fetch failed');
    const sectionsHtml = await sectionsRes.json();

    // 3) construiește payload-ul pe care îl așteaptă renderContents
    const data = { ...cartState, sections: sectionsHtml };

    // 4) rerender corect (nu innerHTML)
    if (typeof cd.renderContents === 'function') {
      cd.renderContents(data);
    } else {
      // fallback: dacă renderContents nu există, atunci abia aici faci replace HTML
      const html = sectionsHtml['cart-drawer'];
      if (html) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newCartDrawer = doc.querySelector('cart-drawer');
        const currentCartDrawer = document.querySelector('cart-drawer');
        if (newCartDrawer && currentCartDrawer) currentCartDrawer.innerHTML = newCartDrawer.innerHTML;
      }
    }

    // 5) deschide drawer-ul
    if (typeof cd.open === 'function') cd.open();

    // 6) notifică restul UI-ului (free shipping bar etc.)
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: cartState }));
    document.dispatchEvent(new CustomEvent('shipping:refresh', { detail: cartState }));
  }

  function init(root) {
    if (!root) return;

    // nu atașa de 100 ori
    if (root.dataset.crossSellInit === '1') return;
    root.dataset.crossSellInit = '1';

    const scroller = root.querySelector('[data-cross-sell-scroller]');
    const prev = root.querySelector('[data-cross-sell-prev]');
    const next = root.querySelector('[data-cross-sell-next]');
    if (scroller && prev && next) {
      const step = () => Math.max(200, scroller.clientWidth * 0.8);
      prev.addEventListener('click', () => scroller.scrollBy({ left: -step(), behavior: 'smooth' }));
      next.addEventListener('click', () => scroller.scrollBy({ left: step(), behavior: 'smooth' }));
    }

    // AJAX add to cart din cross-sell
    root.querySelectorAll('form[data-cross-sell-add]').forEach((form) => {
      if (form.dataset.bound === '1') return;
      form.dataset.bound = '1';

      form.addEventListener('submit', async (e) => {
        e.preventDefault();

        const btn = form.querySelector('button[type="submit"]');
        if (btn) {
          btn.disabled = true;
          btn.dataset.oldText = btn.textContent;
          btn.textContent = 'Adding…';
        }

        try {
          const fd = new FormData(form);

          // 1) adaugă în cart prin AJAX
          const addRes = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: fd
          });

          if (!addRes.ok) {
            const txt = await addRes.text();
            throw new Error('Add failed: ' + txt);
          }

          // 2) refresh corect drawer + evenimente pt shipping
          await refreshDrawerAndNotify();

        } catch (err) {
          console.warn(err);
          // fallback opțional: form.submit();
        } finally {
          if (btn) {
            btn.disabled = false;
            btn.textContent = btn.dataset.oldText || 'Add to cart';
          }
        }
      });
    });
  }

  function boot(scope = document) {
    scope.querySelectorAll('[data-cross-sell]').forEach(init);
  }

  document.addEventListener('DOMContentLoaded', () => boot());

  // Dawn/cart drawer rerender hooks
  document.addEventListener('cart:updated', () => boot());
  document.addEventListener('cart:refresh', () => boot());

  // fallback: observe doar drawer-ul
  const cartDrawer = document.getElementById('CartDrawer');
  if (cartDrawer) {
    const mo = new MutationObserver(() => boot(cartDrawer));
    mo.observe(cartDrawer, { childList: true, subtree: true });
  }
})();
